import DashboardsRoutes from './DashboardsRoutes';

export default DashboardsRoutes;
